import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import type { AppDispatch, RootState } from 'store';
import { PaginateDocumentsActions as PaginateActions } from 'store/ducks/documents';
import { useAuth, usePaginationCache } from 'hooks';
import { Scaffold } from 'layouts';
import {
  DocumentsList,
  DocumentFilters,
  FindDocuments,
} from 'components/Pages/Documents';
import { Paginator, ListingPageHeader } from 'components/Shared';
import * as S from './styles';

export const DocumentsListPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();

  const { paginationCache, updatePaginationCache, handleFilter, handleSort, deletePaginationCache } =
    usePaginationCache('documents');

  const { userBelongsToAnyOf } = useAuth();

  const {
    data: documents,
    pagination,
    loading,
  } = useSelector((state: RootState) => state.paginateDocuments);

  const [query, setQuery] = useState<FindDocuments>({
    search: '',
    page: 1,
    limit: 10,
    ...paginationCache,
  });

  const onPagechange = useCallback((page: number): void => {
    setQuery((state) => ({ ...state, page }));
  }, []);

  const onQueryChange = useCallback((): void => {
    dispatch(PaginateActions.request(query));
  }, [dispatch, query]);

  useEffect(() => {
    onQueryChange();
  }, [onQueryChange]);

  useEffect(() => {
    return () => {
      dispatch(PaginateActions.reset());
      updatePaginationCache(query);
    };
  }, [dispatch, query, updatePaginationCache]);

  return (
    <Scaffold>
      <S.MainPanel>
        <ListingPageHeader
          icon={<S.BookMarkIcon />}
          title="Documentações"
          isLoading={loading}
          actions={
            userBelongsToAnyOf('admin') ? (
              <S.LinkButton to={'/documentacoes/criar'} size="small">
                <S.PlusIcon /> Novo documento
              </S.LinkButton>
            ) : (
              <></>
            )
          }
        />
        <DocumentFilters
          currentFilter={query}
          onFilter={(filter) => handleFilter(query, filter, setQuery)}
        />
        <DocumentsList
          documents={documents}
          currentSort={query}
          onSort={(sort) => handleSort(query, sort, setQuery)}
        />
        <Paginator onPageChange={onPagechange} pagination={pagination} />
      </S.MainPanel>
    </Scaffold>
  );
};
